import React from 'react';

const prefix = 'nxt';
const iconName = 'soundWaveform';
const width = 14;
const height = 12;
const unicode = '';
const svgPathData = '';

const definition = {
  prefix: prefix,
  nxtCustom: true,
  iconName: iconName,
  icon: [width, height, unicode, svgPathData],
  iconDom: (
    <>
      <line stroke="#758BA3" strokeLinecap="round" strokeWidth="2" x1="1" x2="0.999999" y1="3" y2="9" />
      <line stroke="#758BA3" strokeLinecap="round" strokeWidth="2" x1="9" x2="9" y1="3" y2="9" />
      <line stroke="#758BA3" strokeLinecap="round" strokeWidth="2" x1="13" x2="13" y1="5" y2="7" />
      <line stroke="#758BA3" strokeLinecap="round" strokeWidth="2" x1="5" x2="5" y1="1" y2="11" />
    </>
  ),
};

const nxtSoundWaveform = definition;

export { definition, nxtSoundWaveform, prefix, iconName, width, height, unicode, svgPathData };
